import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { InputSearchIcon } from '../../../components/common/input/input';
import Checkbox from '../../../components/common/checkbox/Checkbox';
import PolygonIcon from '../../../assets/icons/polygon.svg';
import './multi-select-dropdown.scss';
export var CustomMultiSelect = function (props) {
    var defaults = props.defaults, options = props.options, onBlur = props.onBlur, isCheckedAll = props.isCheckedAll, validationChecked = props.validationChecked, clickOutside = props.clickOutside, onClickOutside = props.onClickOutside, defaultText = props.defaultText, showLabelText = props.showLabelText, onChangeAllSelect = props.onChangeAllSelect, disabled = props.disabled, isDisableClickOutside = props.isDisableClickOutside;
    var t = useTranslation().t;
    var _a = useState(isCheckedAll ? true : false), checkAll = _a[0], setCheckAll = _a[1];
    var _b = useState(""), defaultSelectText = _b[0], setDefaultSelectText = _b[1];
    var _c = useState(false), showOptionList = _c[0], setShowOptionList = _c[1];
    var _d = useState([]), optionOriginal = _d[0], setOptionOriginal = _d[1];
    var _e = useState([]), optionsList = _e[0], setOptionsList = _e[1];
    var _f = useState(""), keyword = _f[0], setKeyword = _f[1];
    var _g = useState(false), isDisabled = _g[0], setDisabled = _g[1];
    var _h = useState(false), isChangeSelected = _h[0], setChangeSelected = _h[1];
    var _j = useState(false), isClickOutsite = _j[0], setClickOutsite = _j[1];
    var _k = useState(false), isSearchcheckAll = _k[0], setSearchCheckAll = _k[1];
    useEffect(function () {
        if (defaults && options && options.length) {
            var selectedText_1 = "";
            options.forEach(function (option) {
                var foundDefault = defaults.find(function (item) { return item.id == option.id; });
                if (foundDefault) {
                    selectedText_1 += (selectedText_1 ? "," : "") + " " + foundDefault.name;
                }
            });
            setDefaultSelectText(selectedText_1);
        }
    }, []);
    useEffect(function () {
        if (clickOutside) {
            clickOutsizeSelect();
        }
    }, [clickOutside]);
    useEffect(function () {
        setCheckAll(isCheckedAll ? true : false);
    }, [isCheckedAll]);
    useEffect(function () {
        setDisabled(disabled == true ? true : false);
    }, [disabled]);
    useEffect(function () {
        if (isClickOutsite) {
            setClickOutsite(false);
            var selectedOptions = optionOriginal.filter(function (option) { return option.checked; });
            if (validationChecked && (!selectedOptions || !selectedOptions.length)) {
                return;
            }
            setShowOptionList(false);
            if (isChangeSelected) {
                onClickOutsideSelectDropdown();
                setChangeSelected(false);
            }
        }
    }, [isClickOutsite]);
    var clickOutsizeSelect = function () {
        var selectedOptions = optionOriginal.filter(function (option) { return option.checked; });
        if (validationChecked && (!selectedOptions || !selectedOptions.length)) {
            return;
        }
        onBlur(selectedOptions);
    };
    var useOutsideAlerter = function (ref, labelRef) {
        useEffect(function () {
            function handleClickOutside(event) {
                if ((ref.current && !ref.current.contains(event.target)) && (labelRef.current && !labelRef.current.contains(event.target)) && !isDisableClickOutside) {
                    setClickOutsite(true);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, optionOriginal]);
    };
    var onClickOutsideSelectDropdown = function () {
        var selectedOptions = optionOriginal.filter(function (option) { return option.checked; });
        if (validationChecked && (!selectedOptions || !selectedOptions.length)) {
            setDefaultSelectText('');
            return;
        }
        setShowOptionList(false);
        onClickOutside();
    };
    useEffect(function () {
        if (defaults && options) {
            var selectedText_2 = "";
            options.forEach(function (option) {
                var foundDefault = defaults.find(function (item) { return item.id == option.id; });
                if (foundDefault) {
                    selectedText_2 += (selectedText_2 ? "," : "") + " " + option.name;
                }
            });
            setDefaultSelectText(selectedText_2);
            if (defaults.length === options.length) {
                setCheckAll(true);
            }
        }
    }, [defaults, options]);
    useEffect(function () {
        var optionList = [];
        if (options) {
            optionList = _.sortBy(options, function (option) { return option.name; });
            if (defaults) {
                var isCheckAll_1 = true;
                var selectedText_3 = "";
                optionList = optionList.map(function (option) {
                    var foundDefault = defaults.find(function (item) { return item.id == option.id; });
                    option.checked = foundDefault ? true : false;
                    if (!option.checked)
                        isCheckAll_1 = false;
                    if (foundDefault)
                        selectedText_3 += (selectedText_3 ? "," : "") + " " + option.name;
                    return option;
                });
                setDefaultSelectText(selectedText_3);
                setCheckAll(isCheckAll_1);
            }
        }
        setOptionOriginal(optionList);
        setOptionsList(optionList);
    }, [options]);
    var labelRef = useRef(null);
    var selectRef = useRef(null);
    useOutsideAlerter(selectRef, labelRef);
    var onSearchKeyword = function (event) {
        if (event && event.currentTarget && event.currentTarget) {
            var isCheckAll_2 = true;
            var value_1 = event.currentTarget.value;
            var listSearch = _.cloneDeep(optionOriginal);
            listSearch = _.sortBy(listSearch, function (option) { return option.name; });
            listSearch = listSearch.filter(function (searchKey) {
                if (!searchKey.checked)
                    isCheckAll_2 = false;
                var valueKey = searchKey.name.toLowerCase();
                return valueKey.indexOf(value_1.toLowerCase()) > -1;
            });
            if (value_1 && listSearch && listSearch.length) {
                var isSeachCheckedAllOptions = listSearch.every(function (option) { return option && option.checked; });
                setSearchCheckAll(isSeachCheckedAllOptions);
            }
            else {
                setSearchCheckAll(false);
            }
            setKeyword(value_1);
            setCheckAll(isCheckAll_2);
            setOptionsList(listSearch);
        }
    };
    var handleListDisplay = function () {
        var selectedOptions = optionOriginal.filter(function (option) { return option.checked; });
        if ((validationChecked && (!selectedOptions || !selectedOptions.length)) || disabled) {
            return;
        }
        else {
            setShowOptionList(!showOptionList);
            if (!!showOptionList) {
                var listMediaSelected = optionOriginal.filter(function (option) { return option.checked; });
                onBlur(listMediaSelected);
            }
        }
    };
    var onCheckAll = function (checkAll) {
        var selected = "";
        var optionChecks = optionsList.map(function (option) {
            option.checked = checkAll;
            return option;
        });
        var optionOrgs = optionOriginal.map(function (option) {
            if (keyword) {
                var foundOption = optionChecks.find(function (optionCheck) { return optionCheck.id == option.id; });
                if (foundOption) {
                    option.checked = checkAll;
                }
            }
            else {
                option.checked = checkAll;
            }
            if (option.checked)
                selected += (selected ? "," : "") + " " + option.name;
            return option;
        });
        if (onChangeAllSelect) {
            onChangeAllSelect(checkAll);
        }
        if (keyword && optionChecks && optionChecks.length) {
            var isSeachCheckedAllOptions_1 = optionChecks.every(function (option) { return option && option.checked; });
            setSearchCheckAll(isSeachCheckedAllOptions_1);
        }
        else {
            setSearchCheckAll(false);
        }
        var isSeachCheckedAllOptions = optionOrgs.every(function (option) { return option && option.checked; });
        setChangeSelected(true);
        setDefaultSelectText(selected);
        setOptionOriginal(optionOrgs);
        setOptionsList(optionChecks);
        setCheckAll(isSeachCheckedAllOptions);
    };
    var onCheckItem = function (value, check) {
        var isCheckAll = true;
        var selected = "";
        var optionChecks = optionsList.map(function (option) {
            if (value == option.id) {
                option.checked = check;
            }
            // if (!option.checked) {
            //   isCheckAll = false;
            // } else {
            //   selected += `${selected ? "," : ""} ${option.name}`;
            // }
            return option;
        });
        var optionOrgs = optionOriginal.map(function (option) {
            if (value == option.id) {
                option.checked = check;
            }
            if (option.checked) {
                selected += (selected ? "," : "") + " " + option.name;
            }
            return option;
        });
        isCheckAll = optionOriginal.every(function (option) { return option && option.checked; });
        if (isCheckAll && onChangeAllSelect) {
            onChangeAllSelect(isCheckAll);
        }
        if (keyword && optionChecks && optionChecks.length) {
            var isSeachCheckedAllOptions = optionChecks.every(function (option) { return option && option.checked; });
            setSearchCheckAll(isSeachCheckedAllOptions);
        }
        else {
            setSearchCheckAll(false);
        }
        setChangeSelected(true);
        setCheckAll(isCheckAll);
        setDefaultSelectText(selected);
        setOptionOriginal(optionOrgs);
        setOptionsList(optionChecks);
    };
    return (React.createElement("div", { className: "custom-multi-select-container" + (props.selectContainerStyle ? " " + props.selectContainerStyle : ''), ref: selectRef },
        React.createElement("div", { className: (showOptionList ? "selected-text active" : "selected-text") + " " + (isDisabled ? "selected-text-disabled" : "") + " " + (props.dropdownStyle ? props.dropdownStyle : ""), onClick: handleListDisplay },
            React.createElement("div", { className: "label-wraped" + (props.labelStyle ? " " + props.labelStyle : '') },
                React.createElement("span", { className: "label" + (props.labelStyle ? " " + props.labelStyle : '') }, showLabelText ? defaultSelectText : defaultText)),
            React.createElement("div", null,
                React.createElement("img", { src: props.icDropdown ? props.icDropdown : PolygonIcon }))),
        showOptionList && (React.createElement("div", { className: "media-list", ref: labelRef },
            React.createElement("div", { className: "media-search-section" },
                React.createElement(InputSearchIcon, { type: "text", onChange: onSearchKeyword, iconName: "search", value: keyword, placeholder: "" + t("common.keyword"), className: "media-search-input", onPressEnter: onSearchKeyword })),
            validationChecked && !defaultSelectText ? React.createElement("div", { className: "validation-select" },
                React.createElement("span", null, "Please choose option")) : null,
            React.createElement("div", { className: "media-panel" },
                optionsList && optionsList.length ?
                    React.createElement("div", { className: "checkbox-all" },
                        React.createElement(Checkbox, { label: keyword ? t("common.all_result") : t("common.all"), key: "media-all-option", value: "ALL_OPTION", checked: isSearchcheckAll || checkAll, onChecboxValueChanged: function (value, checked) { return onCheckAll(checked); } })) : null,
                optionsList && optionsList.length ? optionsList.map(function (item) { return React.createElement(Checkbox, { id: "media-" + item.id, label: item.name, value: item.id, key: "media-" + item.id, checked: item.checked, onChecboxValueChanged: function (value, checked) { return onCheckItem(value, checked); } }); }) : null)))));
};
export default CustomMultiSelect;
